(function notificationConfigControllerDefinition() {
    'use strict';

    angular.module('NotificationConfig')
        .controller('NotificationConfigAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'authExtend', '$filter', 'adminNotificationConfigService', 'adminDocumentTypeService', 'adminRoleService', 'notificationService', 'functionService', 'userService', '$uibModal',
            function NotificationConfigAddController($scope, config, $state, $translate, errors, authExtend, $filter, adminNotificationConfigService, adminDocumentTypeService, adminRoleService, notificationService, functionService, userService, $modal) {
                $scope.load = function () {
                    $scope.aux = {
                        name: null,
                        templateId: null,
                        templateName: null,
                        documentTypeId: null,
                        metadataId: null,
                        daysToNotification: 0,
                        time: {},
                        roleId: null,
                        notForCreator: true,
                        appId: null,
                        metadatas: [],
                        configurationTypeId: null,
                        configurationTypeName: null,
                        recipientType: 'Role',
                        mailRecipient: '',
                        organizationalUnit: undefined
                    };

                    $scope.isEditable = true;
                    $scope.metadatas = [];

                    $scope.userData =
                        {
                            idObject: 'userControl',
                            metadataIsRequired: false,
                            metadataValue: undefined,
                            metadataType: 'userControl',
                            metadataLabel: 'Usuario',
                            metadataReplicate: false,
                            metadataSystemName: '_usuario',
                            metadataReadOnly: false,
                            metadataEnabled: true
                        };
                    
                    $scope.canConfigApps = authExtend.isInRole('CONFIG ADMIN APPS');
                    $scope.optionsTimes = [{ name: "Antes" }, { name: "Después" }];
                    $scope.aux.time = $scope.optionsTimes[0];

                    notificationService.getTemplates('EDR').then(function (result) {
                        $scope.optionsTemplates = result;
                    }, function (error) {
                        errors.showError(error);
                    });

                    if (!$scope.canConfigApps) {
                        $scope.aux.appId = config.appId();
                        adminRoleService.get(null, $scope.aux.organizationalUnitId, null).then(function (result) {
                            $scope.optionsRoles = result.value;
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                    else {
                        functionService.getApps().then(function getOk(result) {
                            $scope.optionApps = result;
                        }, function getError(error) {
                            errors.showError(error);
                        });
                    }
                }

                $scope.cancel = function () {
                    $state.go('notification-config-find');
                };

                $scope.selectTemplate = function (item) {
                    $scope.aux.templateId = item.id;
                    $scope.aux.templateName = item.name;
                };

                $scope.selectConfigurationType = function (item) {
                    $scope.aux.configurationTypeId = item.id;
                    $scope.aux.configurationTypeName = item.name;

                    $scope.clearMetadata();
                    $scope.clearDateMetadata();
                };

                $scope.selectTime = function (item) {
                    $scope.aux.time = item;
                };

                $scope.selectRole = function (item) {
                    $scope.aux.roleId = item.id;
                    $scope.clearSelectedCombos("Role");

                    adminDocumentTypeService.getRoleDocumentTypes(item.id).then(function (result) {
                        $scope.optionsDocumentTypes = result.sort(function (a, b) {
                            return a.name.localeCompare(b.name);
                        });
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.selectDocumentType = function (item) {
                    $scope.aux.documentTypeId = item.id;
                    $scope.clearSelectedCombos("DocumentType");
                    $scope.optionsConfigurationType = [];
                    $translate(['NotificationConfigTypePublish'])
                        .then(function (translated) {
                            var publish = {
                                id: 1,
                                name: translated.NotificationConfigTypePublish
                            };
                            $scope.optionsConfigurationType.push(publish);
                        });

                    adminDocumentTypeService.getById($scope.aux.documentTypeId).then(function (result) {
                        $scope.documentType = {
                            metadatas: []
                        };
                        $scope.emptyMetadatas = null;
                        $scope.optionMetadatas = null;
                        $scope.optionCombos = null;

                        if (result.metadata.length > 0) {

                            $scope.optionMetadatas = $filter('filter')(result.metadata, { metadataType: 'date' });
                            if ($scope.optionMetadatas.length > 0) {
                                $translate(['NotificationConfigTypeDate'])
                                    .then(function (translated) {
                                        var publish = {
                                            id: 2,
                                            name: translated.NotificationConfigTypeDate
                                        };
                                        $scope.optionsConfigurationType.push(publish);
                                    });
                            }

                            var metadatas = [];

                            $scope.optionCombos = $filter('filter')(result.metadata, { metadataType: 'combo' });

                            $scope.optionCombos.forEach(function (metadata) {
                                var selectedItems = [];
                                var optionValues = JSON.parse(metadata.optionValues);
                                var values = [];
                                var checked = false;
                                var selectValues = false;
                                var placeHolder = "NotificationAllMetadataCombo";

                                selectedItems = values;

                                metadatas.push(
                                    {
                                        selectedItems: selectedItems,
                                        checked: checked,
                                        selectValues: selectValues,
                                        placeHolder: placeHolder,
                                        metadataId: metadata.metadataId,
                                        metadataType: metadata.metadataType,
                                        metadataSystemName: metadata.metadataSystemName,
                                        metadataLabel: metadata.metadataLabel,
                                        metadataOptions: optionValues,
                                    });
                            });

                            $scope.emptyMetadatas = clone(metadatas);
                            $scope.documentType.metadatas = metadatas;

                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.toggleSelectValues = function (item) {
                    item.selectedItems = [];
                    item.placeHolder = item.selectValues ? "NotificationSelectMetadataCombo" : "NotificationAllMetadataCombo";
                };

                $scope.selectApplication = function (item) {
                    $scope.aux.appId = item.id;
                    $scope.clearSelectedCombos("App");
                    $scope.recipientTypeChanged();

                    adminRoleService.get(null, $scope.aux.organizationalUnitId, null, item.id).then(function (result) {
                        $scope.optionsRoles = result.value;
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.searchUser = function () {
                    if (!$scope.aux.selectedUser || !$scope.aux.selectedUser.nickName || $scope.aux.selectedUser.nickName.length < 1) {
                        $scope.openModalUser();
                    }
                    else {
                        $scope.selectUser();
                    }
                };

                $scope.openModalUser = function () {
                    $scope.find.selectedUser = {};
                    var modalInstance = $modal.open({
                        templateUrl: '/app/directives/custom-control-user/custom-control-user-modal.html',
                        controller: 'UserSearchModalController',
                        size: 'lg',
                        resolve: {
                            ouId: function () {
                                return $scope.ouId;
                            },
                            info: function () {

                            }
                        }
                    });

                    modalInstance.result.then(function (result) {
                        if (result) {
                            $scope.selectedUser(result);
                        }
                        else {
                            $scope.aux.selectedUser = {};
                        }
                    });
                };


                $scope.change = function (user) {
                    if (!user) {
                        $scope.aux.selectedUser = user;
                        $scope.aux.UserRecipient = undefined;
                        return; 
                    }

                    $scope.aux.selectedUser = user;
                    $scope.aux.UserRecipient = user.id;
                    $scope.clearSelectedCombos("Role");
                    adminDocumentTypeService.get(undefined, undefined, undefined, $scope.aux.appId).then(function (result) {
                        $scope.optionsDocumentTypes = result.sort(function (a, b) {
                            return a.name.localeCompare(b.name);
                        });
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.recipientTypeChanged = function () {
                    $scope.clearSelectedCombos("Role");
                    switch ($scope.aux.recipientType) {
                        case "Role":
                            $scope.aux.role = null;
                            break;
                        case "Mail":
                            adminDocumentTypeService.get(undefined, undefined, undefined, $scope.aux.appId).then(function (result) {
                                $scope.optionsDocumentTypes = result.sort(function (a, b) {
                                    return a.name.localeCompare(b.name);
                                });
                            }, function (error) {
                                errors.showError(error);
                            });
                            break;
                        case "User":
                            $scope.userData =
                                {
                                    idObject: 'userControl',
                                    metadataIsRequired: false,
                                    metadataValue: undefined,
                                    metadataType: 'userControl',
                                    metadataLabel: 'Usuario',
                                    metadataReplicate: false,
                                    metadataSystemName: '_usuario',
                                    metadataReadOnly: false,
                                    metadataEnabled: true
                                };
                            break;
                    }
                };

                $scope.save = function () {
                    if (!$scope.notificationsForm.$valid) {
                        $scope.notificationsForm.$setSubmitted();
                        if ($scope.notificationsForm.$error["email"]) {
                            errors.showError('VerifyMailRecipient');
                            return;
                        }

                        errors.showError('VerifyFormData');
                        return;
                    }

                    if ($scope.aux.recipientType === "Mail" && $scope.aux.mailRecipient.length < 1) {
                        errors.showError('VerifyMailRecipient');
                        return;
                    }

                    if ($scope.aux.recipientType === "Role" && !$scope.aux.roleId) {
                        errors.showError('VerifyRoleRecipient');
                        return;
                    }

                


                    $scope.prepareMetadatas();

                    //If the user cannot set the notForCreator we must set it to false.
                    if ($scope.aux.configurationTypeId !== 1) {
                        $scope.aux.notForCreator = false;
                    }

                    $scope.aux.organizationalUnitId = $scope.aux.organizationalUnit.id;
                    $scope.aux.organizatioanlUnitName = $scope.aux.organizationalUnit.name;

                    $scope.aux.daysToNotification = $scope.aux.time.name === 'Antes' ? ($scope.aux.daysToNotification * - 1) : $scope.aux.daysToNotification;

                    return adminNotificationConfigService.create($scope.aux).then(function () {
                        $state.go('notification-config-find');
                    }, function (error) {
                        $scope.aux.daysToNotification = $scope.aux.time.name === 'Antes' ? ($scope.aux.daysToNotification * - 1) : $scope.aux.daysToNotification;
                        errors.showError(error);
                    });
                };

                $scope.prepareMetadatas = function () {
                    $scope.documentType.metadatas.forEach(function (item) {
                        var isValid = true;
                        var dataValue = [];
                        if (item.selectValues) {
                            if (item.selectedItems.length > 0) {
                                var metadata = {
                                    metadataId: item.metadataId,
                                    systemName: item.metadataSystemName,
                                    values: "",
                                    allValues: !item.selectValues
                                };

                                if (!item.selectedItems[0].value) {
                                    item.selectedItems.forEach(function (val) {
                                        var v = {
                                            value: ""
                                        };
                                        v.value = val;
                                        dataValue.push(v);
                                        metadata.values = angular.toJson(dataValue);
                                    });
                                }
                                else {
                                    var options = [];
                                    item.selectedItems.forEach(function (val) {
                                        // no guardo la descripcion
                                        options.push({ value: val.value });
                                    });

                                    metadata.values = angular.toJson(options);
                                }
                                $scope.aux.metadatas.push(metadata);
                            }
                        }
                        else {
                            metadata = {
                                metadataId: item.metadataId,
                                systemName: item.metadataSystemName,
                                values: "",
                                allValues: !item.selectValues
                            };
                            $scope.aux.metadatas.push(metadata);
                        }
                    });
                }

                $scope.clearSelectedCombos = function (current) {
                    if (current === "App") {
                        $scope.aux.roleId = null;
                        $scope.aux.role = null;
                        $scope.optionsRoles = [];
                    }

                    if (current === "App" || current === "Role") {
                        $scope.aux.documentTypeId = null;
                        $scope.aux.documentType = null;
                        $scope.optionsDocumentTypes = [];
                    }

                    $scope.aux.configurationTypeId = null;
                    $scope.aux.configurationTypeName = null;
                    $scope.aux.configurationType = null;
                    $scope.optionsConfigurationType = [];
                    $scope.aux.templateId = null;
                    $scope.aux.templateName = null;
                    $scope.aux.template = null;
                    $scope.aux.forComboMetadata = false;

                    $scope.clearMetadata();
                    $scope.clearDateMetadata();
                };

                $scope.clearMetadata = function () {
                    $scope.documentType = {
                        metadatas: []
                    };

                    if ($scope.emptyMetadatas) {
                        $scope.documentType.metadatas = clone($scope.emptyMetadatas);
                    }
                };

                $scope.clearDateMetadata = function () {
                    $scope.aux.metadataId = null;
                    $scope.aux.daysToNotification = 0;
                };


                $scope.toggleForComboMetadata = function () {
                    if (!$scope.aux.forComboMetadata) {
                        $scope.clearMetadata();
                    }
                };

                function clone(obj) {
                    return JSON.parse(JSON.stringify(obj));
                }

                $scope.load();
            }
        ]);
})();